import { uniqueId } from "library/database/split-id.mjs"

export function areSkillSetsSemanticallyEqual(left, right, skillsIndex = null) {
    const normalizedLeft = normalizeSkillSetForComparison(left, skillsIndex)
    const normalizedRight = normalizeSkillSetForComparison(right, skillsIndex)
    return normalizedLeft === normalizedRight
}

export function normalizeSkillSetForComparison(value, skillsIndex = null) {
    const normalizedValue = normalizeSkillIdentifier(value)
    if (!normalizedValue) return null

    const directSkill = skillsIndex?.[normalizedValue]
    if (directSkill) return normalizeSkillIdentifier(directSkill)

    const matchingSkill = findSkillByLabelOrCode({ normalizedValue, value, skillsIndex })
    if (matchingSkill) return normalizeSkillIdentifier(matchingSkill)

    return normalizedValue
}

function findSkillByLabelOrCode({ normalizedValue, value, skillsIndex }) {
    if (!skillsIndex) return null

    const normalizedLabel = normalizeSkillLabel(value)
    for (const skill of Object.values(skillsIndex)) {
        if (!skill) continue
        if (normalizeSkillIdentifier(skill) === normalizedValue) return skill
        if (normalizeSkillLabel(skill.SkillingCode) === normalizedLabel) return skill
        if (normalizeSkillLabel(skill.Skilling) === normalizedLabel) return skill
    }

    return null
}

function normalizeSkillIdentifier(value) {
    const rawValue = getSkillIdentifierValue(value)
    if (rawValue == null) return null

    const normalized = `${rawValue}`.trim()
    if (!normalized) return null

    return `${uniqueId(normalized)}`.trim()
}

function getSkillIdentifierValue(value) {
    if (value?.CoreSkillingID != null) return value.CoreSkillingID
    if (value?._id != null) return value._id
    if (value?.id != null) return value.id
    return value
}

function normalizeSkillLabel(value) {
    if (value == null) return null
    const normalized = `${value}`.trim()
    return normalized || null
}
